import React from 'react';

import { Button, ButtonProps, useMantineTheme } from '@mantine/core';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';

interface BubbleButtonProps extends ButtonProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  onClick?: () => void;
}

export function BubbleButton({ smartAssistantVisualConfig, ...buttonProps }: BubbleButtonProps) {
  const theme = useMantineTheme();
  const bgColor = smartAssistantVisualConfig.userMessageColor;
  const textColor = theme.other.getReadableColor(bgColor);

  return (
    <Button
      styles={{
        root: {
          backgroundColor: bgColor,
          color: textColor,
          '&:hover': {
            backgroundColor: bgColor,
            opacity: 0.9
          }
        }
      }}
      {...buttonProps}
    />
  );
}
